<template>
  <modal ref='modal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('record_show.delete_file') }}</h5>
    </template>

    <template #body>
      <form @submit.prevent='deleteFile' class="modal-fix">
        <div class='modal-body'>
          <p>{{ $t('record_show.delete_label') }}</p>
        </div>

        <div class='modal-footer'>
          <input @click.prevent='$refs.modal.close' type='submit' :value="$t('folder_show.modals.delete.cancel')" class="btn btn-outline-primary">
          <input type='submit' :value="$t('folder_show.modals.delete.submit')" class='btn btn-danger' />
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        record: {},
      }
    },
    methods: {
      open(record) {
        this.record = Object.assign({}, record)
        this.$refs.modal.open()
      },
      deleteFile() {
        this.store.destroyRecord(this.record).then(() => {
          this.store.sendMetrics({name: 'remove_file', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
          this.$refs.modal.close()
        })
      }
    }
  }
</script>
